import React from "react";

import Container from 'react-bootstrap/Container';

import "./ScheduleAppointment.scss";

export default function ScheduleAppointment() {
    return (
        <section className="schedule-section">
            <Container>
                <header className="schedule-header">
                    <span className="schedule-welcome">Welcome</span>
                    <h2 className="schedule-title">Schedule an Appointment</h2>
                    <hr className="schedule-divider" />
                </header>

                <div className="schedule-cards">
                    <div className="schedule-card schedule-card--new">
   
                        <h3 className="schedule-card__heading">Book your appointment</h3>
                        <p className="schedule-card__body">
                        Click below to schedule a new patient appointment or a follow-up visit with Better Days Psychiatry and Family Practice.
                        </p>
                        <button
                            type="button"
                            className="schedule-btn schedule-btn--primary"
                            onClick={() => { window.open('https://betterdays.intakeq.com/booking', '_blank'); }}
                        >
                            Schedule an Appointment →
                        </button>
                    </div>
                </div>
            </Container>
        </section>
    );
}
